import { Box, styled } from "@mui/material";
import TextStepName from "../../UI/Typography/TextStepName";
import { ZusammenfassungLayout } from "./styles";
import ZusammenfassungList from "./components/ZusammenfassungList";
import ZusammenfassungParameters from "./components/ZusammenfassungParameters";
import FormInput from "../../UI/FormInput";
import TextArea from "../../UI/TextArea";
import useAppSelector from "../../../hooks/useSelector";
import useAppDispatch from "../../../hooks/useDispatch";
import { setComment } from "../../../store/contactSlice";
import { useTranslation } from "react-i18next";

const Wrapper = styled(Box)`
  padding-bottom: 55px;
  ${({ theme }) => theme.breakpoints.down("lg")} {
    flex: 1;
    height: 100%;
    overflow-y: scroll;
  }
`;

const Zusammenfassung = () => {
  const { t } = useTranslation();
  const comment = useAppSelector((state) => state.contact.comment);
  const dispatch = useAppDispatch();

  const handleChangeComment = (value: string) => {
    dispatch(setComment(value));
  };

  return (
    <Wrapper>
      <TextStepName sx={{ marginBottom: "28px" }}>
        {t("key-summary.title")}
      </TextStepName>
      <ZusammenfassungLayout>
        <ZusammenfassungList />
        <ZusammenfassungParameters />
        <Box sx={{ paddingY: "16px" }}>
          <FormInput label="" sx={{ gap: "unset" }}>
            <TextArea
              value={comment}
              minRows={20}
              maxRows={20}
              placeholder={t("order.comment")}
              onChange={(e) => handleChangeComment(e.target.value as string)}
            />
          </FormInput>
        </Box>
      </ZusammenfassungLayout>
    </Wrapper>
  );
};

export default Zusammenfassung;
